import { render, staticRenderFns } from "./IntegrationFormPagerduty.vue?vue&type=template&id=c3a15680&scoped=true"
import script from "./IntegrationFormPagerduty.vue?vue&type=script&lang=js"
export * from "./IntegrationFormPagerduty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a15680",
  null
  
)

export default component.exports